// src/hooks/useJWT.js
import { useContext } from 'react';
import JWTContext from '../context/JWTContext';

const useJWT = () => useContext(JWTContext);
export default useJWT;
